import { DEVICE_NAMES } from 'constants/miscellaneous';
import { isIOS, isAndroid, isWindows, isMac, isUbuntu } from './isMobile';

const INITIAL = 'initial';

const { ANDROID, MAC, WINDOWS, UBUNTU } = DEVICE_NAMES;

export const getFontPlatform = () => {
  switch (true) {
    case isAndroid:
      return ANDROID;
    case isIOS:
      return MAC;
    case isWindows:
      return WINDOWS;
    case isMac || isUbuntu:
      return UBUNTU;
    default:
      return INITIAL;
  }
};
